import { reactive, computed } from "@nuxtjs/composition-api";
import { pick } from "lodash";
import useRequest from "./useRequest";

export default function usePagination(
  service,
  defaultData = {
    list: [],
    page_index: 1,
    total_count: 0,
    total_size: 0,
    total_page: 0,
  },
  options = {
    immediate: true,
  }
) {
  // 是否可以加载更多
  const enabledLoadMore = computed(() => pagination.page_index < pagination.total_page)
  const pagination = reactive({
    page_index: 1,
    page_size: 10,
    total_page: 1,
    total_count: 1,
  });
  const { execute, state, isReady, ...rest } = useRequest(
    service,
    defaultData,
    {
      ...options,
      immediate: false
    }
  );

  async function fetchList() {
    let data = await execute(0, pagination);

    Object.assign(
      pagination,
      pick(data, ["page_index", "page_size", "total_count", "total_size", 'total_page'])
    );

    // console.log(pagination)

    return data;
  }

  function onPageChange(page_index = 0) {
    pagination.page_index = page_index;
    fetchList();
  }

  function onPageSizeChange(page_size = 10) {
    pagination.page_size = page_size;
    fetchList();
  }

  function onSearch() {
    pagination.page_index = 1;
    fetchList();
  }

  if (options.immediate) {
    fetchList();
  }

  return {
    ...rest,
    isReady,
    execute: fetchList,
    pagination,
    enabledLoadMore,
    state,

    onPageChange,
    onPageSizeChange,
    onSearch,
  };
}
